
import React from 'react';

import JsonView from '@uiw/react-json-view';

export default function CommonJsonViewer({ jsonObject }) {

    return <JsonView value={jsonObject} />
}

